<template>
    <div>
      <transition name="fade">
        <div class="alert alert-success" role="alert" v-if="variant === 'success'">
          <strong>Gelukt:</strong> {{ message }}
        </div>
        <div class="alert alert-danger" role="alert" v-if="variant === 'danger'">
          <strong>Mislukt:</strong> {{ message }}
        </div>
        <div class="alert alert-warning" role="alert" v-if="variant === 'warning'">
          <strong>Waarschuwing:</strong> {{ message }}
        </div>
      </transition>
    </div>
</template>

<script>
export default {
  props: ['variant', 'message']
}
</script>



// WEBPACK FOOTER //
// src/components/Alert.vue